import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import { CSCMollieGeneric, TrydentMollieGenericData } from './mollie-generic.js'
import {
  MollieBanContactPayload,
  MollieBelfiusPayload, MollieBlikPayload,
  MollieEPSPayload, MollieIdealPayload,
  MollieKBCCBCPayload,
  MolliePayPalPayload,
  MolliePrzelewy24Payload,
  MollieTrustlyPayload,
  MollieBankTransferPayload,
} from '@cloudsuite/cs-payment-defs'
import {
  GenericStartMolliePaymentPayload,
} from 'components/ordering/checkout/payment-methods/payment-backend/start-payment-api.js'


type GenericMethodId = 'bancontact' | 'paypal' | 'belfius' | 'kbc' | 'eps' | 'ideal' | 'przelewy24' | 'trustly' | 'blik' | 'banktransfer'
type TrydentMollieGenericResponse = {
  custom_description: string,
  mollie_data: TrydentMollieGenericData & { id: GenericMethodId }
}

export const idToPayloadTypeMap: Record<GenericMethodId, GenericStartMolliePaymentPayload> = {
  bancontact: new MollieBanContactPayload(),
  paypal: new MolliePayPalPayload(),
  belfius: new MollieBelfiusPayload(),
  kbc: new MollieKBCCBCPayload(),
  eps: new MollieEPSPayload(),
  ideal: new MollieIdealPayload(),
  przelewy24: new MolliePrzelewy24Payload(),
  trustly: new MollieTrustlyPayload(),
  blik: new MollieBlikPayload(),
  banktransfer: new MollieBankTransferPayload(),
}

export const parseMollieGeneric = (value: unknown, selectedPaymentMethod: string): CSCMollieGeneric | typeof CouldNotParse => {
  if (is<TrydentMollieGenericResponse>(value)) {
    const state = value.mollie_data.id === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCMollieGeneric(
      value.mollie_data,
      state,
      value.custom_description,
      idToPayloadTypeMap[value.mollie_data.id],
    )
  }
  return CouldNotParse
}
